import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "@/components/Logo";

const LINKS = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "Portfolio", to: "/portfolio" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

const linkCls = (isActive) =>
  `text-sm font-sans tracking-wide transition-colors duration-300 ${
    isActive ? "text-turquoise" : "text-cream/75 hover:text-champagne"
  }`;

const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="nav-header"
      className="fixed top-0 inset-x-0 z-50 bg-charcoal/90 backdrop-blur-xl border-b border-champagne/15"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-[72px]">
          <Link to="/" aria-label="Home" data-testid="nav-home-link" onClick={() => setOpen(false)}>
            <Logo dark />
          </Link>

          <nav className="hidden md:flex items-center gap-8" aria-label="Primary">
            {LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                data-testid={`nav-link-${l.label.toLowerCase()}`}
                className={({ isActive }) => linkCls(isActive)}
              >
                {l.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden md:block">
            <Link
              data-testid="nav-get-website-button"
              to="/contact"
              className="inline-block bg-turquoise text-charcoal hover:bg-turquoise-dark px-6 py-2.5 rounded-full font-sans font-semibold text-sm whitespace-nowrap shadow-lg hover:shadow-xl transition-[background-color,box-shadow,transform] duration-300 hover:-translate-y-0.5"
            >
              Get My Website
            </Link>
          </div>

          <button
            data-testid="nav-mobile-menu-button"
            className="md:hidden text-cream p-2"
            onClick={() => setOpen(!open)}
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-champagne/10 bg-charcoal px-4 py-6 space-y-4" data-testid="nav-mobile-menu">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `block w-full text-left font-sans text-base py-2 ${
                  isActive ? "text-turquoise" : "text-cream/85"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            data-testid="nav-mobile-get-website-button"
            to="/contact"
            onClick={() => setOpen(false)}
            className="block w-full text-center bg-turquoise text-charcoal px-6 py-3 rounded-full font-sans font-semibold text-sm"
          >
            Get My Website
          </Link>
        </div>
      )}
    </header>
  );
};

export default Navbar;
